import { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import auth from "../../firebase.init";

const useAdmin = () => {
  const [admin, setAdmin] = useState("");
  const [adminLoading, setAdminLoading] = useState(true);
  const [user, loading] = useAuthState(auth);

  useEffect(() => {
    const email = user?.email;

    if (email) {
      fetch(`${process.env.REACT_APP_API_URL}/users/email/${email}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((data) => {
          setAdmin(data?.data[0]?.role);
          localStorage.setItem("role", data?.data[0]?.role);
          setAdminLoading(false);
        });
    }
  }, [user]);
  return [admin, adminLoading];
};

export default useAdmin;
